module.exports = __webpack_public_path__ + "img/billingdetails.abc89283.svg";